function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7988 20.5059L20.6523 21.3595V20.1523V3.65234C20.6523 3.02612 20.4083 2.48431 19.9475 2.05246C19.5157 1.59171 18.9739 1.34766 18.3477 1.34766H3.65234C3.02129 1.34766 2.46746 1.59496 2.00973 2.0527C1.57203 2.4904 1.34766 3.03302 1.34766 3.65234V14.6523C1.34766 15.2705 1.5707 15.8199 1.99588 16.2805L2.00266 16.2879L2.00973 16.295C2.46746 16.7527 3.02129 17 3.65234 17H16.2929L19.7988 20.5059ZM6 6H16V6.84766H6V6ZM6 8.75H16V9.59766H6V8.75ZM6 11.5H16V12.3477H6V11.5Z",
  stroke: "white"
});
function SvgIcnComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnComment);
export default __webpack_public_path__ + "static/media/icn-comment.b8a5dc0d589efd42ce97bca5f9d07b03.svg";
export { ForwardRef as ReactComponent };